<template>
  <vx-card class="no-shadow border border-solid">
    <h2 class="w-full text-4xl font-bold">the first chapter</h2>

    <p class="my-4">This is you now, or at least some of the most essential areas of yourself and your surroundings.</p>

   <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.work" icon="BriefcaseIcon" :readonly="true" title="Work" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.wealth" icon="DollarSignIcon" :readonly="true" title="Wealth" class="md:mr-16 mb-2"/>
    </div>
  </div>

  <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.spirituality" icon="SunriseIcon" :readonly="true" title="Spirituality" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.health" icon="ActivityIcon" :readonly="true" title="Health" class="md:mr-16 mb-2"/>
    </div>
  </div>
  <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.growth" icon="BookIcon" :readonly="true" title="Growth" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.relationships" icon="HeartIcon" :readonly="true" title="Relationships" class="md:mr-16 mb-2"/>
    </div>
  </div>

  <div class="md:flex w-full justify-center">
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.play" icon="UsersIcon" :readonly="true" title="Play" class="md:mr-16 mb-2"/>
    </div>
    <div class="flex w-full">
      <FirstChapterItem v-model="firstChapter.environment" icon="ImageIcon" :readonly="true" title="Environment" class="md:mr-16 mb-2"/>
    </div>
  </div>

  <p class="mt-4 text-dark">
    Are you satisfied or not? Do you want to improve anything or not? From now on, stop comparing yourself to others, you have your own race to run.
  </p>

  <p class="mt-4 text-lg font-black text-dark">Let's make the next chapter unforgettable.</p>

  <p class="text-center text-gray mt-8 text-pink">„Overnight success stories take a long time.“ — Steve Jobs</p>
</vx-card>
</template>

<script>
import FirstChapterItem from './FirstChapterItem'
export default {
  components: {
    FirstChapterItem
  },
  props: ['firstChapter'],
  data () {
    return {
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>




